import { createSelector } from "reselect";

const regionsState = (state) => state.regions;

export const selectRegions = createSelector(regionsState, (regions) => regions.all.items);
